__turbopack_context__.v({
  "article": "FeaturedArticle-module-scss-module__FZtKTa__article",
  "content": "FeaturedArticle-module-scss-module__FZtKTa__content",
  "content-block": "FeaturedArticle-module-scss-module__FZtKTa__content-block",
  "description": "FeaturedArticle-module-scss-module__FZtKTa__description",
  "featured-article": "FeaturedArticle-module-scss-module__FZtKTa__featured-article",
  "thumbnail": "FeaturedArticle-module-scss-module__FZtKTa__thumbnail",
  "thumbnail-wrapper": "FeaturedArticle-module-scss-module__FZtKTa__thumbnail-wrapper",
  "wrapper": "FeaturedArticle-module-scss-module__FZtKTa__wrapper",
});
